import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgBus2 = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M19.559 1.577H3.565a2 2 0 0 0-2 2V16.56l.005.164a2.5 2.5 0 0 0 2.33 2.33l.206.006.003.019a3 3 0 0 0 2.954 2.479l.177-.006a3 3 0 0 0 2.742-2.299l.039-.193h3.082l.003.018a3 3 0 0 0 2.955 2.48l.186-.007.176-.017a3.014 3.014 0 0 0 2.557-2.282l.039-.192h.04a2.5 2.5 0 0 0 2.5-2.5V3.577a2 2 0 0 0-2-2Zm-15.994 2h15.994V16.56a.5.5 0 0 1-.5.5h-.998a1 1 0 0 0-1 1v.498a1 1 0 0 1-.924.997l-.113.003c-.515 0-.963-.448-.963-1v-.498a1 1 0 0 0-1-1H9.063a1 1 0 0 0-1 1v.498a1 1 0 0 1-1.999 0v-.498a1 1 0 0 0-1-1h-1a.5.5 0 0 1-.5-.5V3.577Z" />
      <path d="M20.559 10.059a1 1 0 0 1 .116 1.993l-.116.007h-18a1 1 0 0 1-.117-1.994l.117-.006h18Z" />
      <path d="M16.559 5.059h-10a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1Zm-1 2v3h-8v-3h8ZM7.559 13.559a1 1 0 0 1 .116 1.993l-.116.007h-1a1 1 0 0 1-.117-1.994l.117-.006h1ZM16.559 13.559a1 1 0 0 1 .116 1.993l-.116.007h-1a1 1 0 0 1-.117-1.994l.117-.006h1Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgBus2)
const Memo = memo(ForwardRef)
export default Memo
